import { mapToReviews } from '@backmarket/nuxt-layer-cms/Reviews.utils'
import { useExperiments } from '@backmarket/nuxt-module-experiments/useExperiments'
import { useHttpFetch } from '@backmarket/nuxt-module-http-v2/useHttpFetch'
import { useMarketplace } from '@backmarket/nuxt-module-marketplace/useMarketplace'

import { getMatchingReviewId } from '~/scopes/product/components/GalleryNew/components/Review/Review.utils'

export function useFetchReviewInCarousel() {
  const experiments = useExperiments()
  const marketplace = useMarketplace()
  const $httpFetch = useHttpFetch()

  return async function fetchReviewInCarousel({
    categoryId,
    productBrand,
    productModel,
    fetchOptions,
  }: {
    categoryId: string
    productBrand: string
    productModel: string
    fetchOptions?: {
      timeout?: number
    }
  }) {
    const isEnabledFF =
      experiments['experiment.ppReviewsInCarousel'] === 'withReviewsInCarousel'

    if (!isEnabledFF) {
      return undefined
    }

    const reviewIds = (() => {
      if (!categoryId) return null

      const matchingReviewIds = getMatchingReviewId({
        countryCode: marketplace.market.countryCode,
        categoryId,
        productBrand,
        productModel,
      })

      return matchingReviewIds
    })()

    // Don't make the request if there are no reviewIds
    if (!reviewIds) {
      return undefined
    }

    const res = await $httpFetch('/reviews/v1/products/reviews', {
      query: { public_id__in: reviewIds },
      ...fetchOptions,
    })

    const mappedReviews = mapToReviews(res.results)

    // returns only the first review that has pictures
    return mappedReviews[0]
      ? { ...mappedReviews[0], count: res.count }
      : undefined
  }
}
